import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import AlertBar from "./components/AlertBar";

import Home from "./pages/Home";
import AboutAiota from "./pages/AboutAiota";
import AboutLogo from "./pages/AboutLogo_Aiotaj";
import VisionMission from "./pages/VisionMission";
import ExecutiveMembers from "./pages/ExecutivesAiota";
import AiotaElections from "./pages/AiotaElection";
import AcotExecutiveMembers from "./pages/ACOT_Executive";
import OccupationalTherapyPrograms from "./pages/ACOT_AccreditedColleges";
import GuidelinesPage from "./pages/Facot";
import CertificationResources from "./pages/Certificateresource";
import ProfessionalAdvancement from "./pages/ProfessionalAdvancement";
import EDCCMembers from "./pages/EDCC";
import ErgonomicCertification from "./pages/companylist";
import WFOTMembership from "./pages/WFOT";
import HomePage from "./pages/Contact_us";
import HelpSupportPage from "./pages/Helpsupport";
import DownloadsPage from "./pages/Downloads";
import MemberLogin from "./pages/Aiota_memberlogin";
import EDCCMemberRegister from "./pages/EDCCRegister";
import EDCCMemberLogin from "./pages/EDCCLogin";
import LifeMembershipTerms from "./pages/AiotaTermsConditions";
import CombinedStepperForm from "./pages/CombinedStepperForm";
import EDCCTermsAndConditions from "./pages/EDCCTermsConditions";
import EDCCOldMemberTermsConditions from "./pages/EDCCOldMemberTermsConditions";
import OldMemberTermsConditions from "./pages/OldMemberTermsConditions";
import OldMemberForm from "./pages/OldMemberForm";
import ProfilePage from "./pages/ProfilePage";
import EDCCLogin from "./pages/EdccOtp";
import ScrollToTopButton from "./pages/ScrollToTopButton";
import AIOTAPaymentPage from "./pages/AIOTA_Payment";
import EDCCProfilePage from "./pages/EDCCProfiel";
import EDCCCombinedStepperForm from "./pages/EDCCForm";
import EDCCOldMemberForm from "./pages/EDCCOldMemberForm";
import WebinarPage from "./pages/Webinar";
import AssociateMemberWelcomePage from "./pages/AssociatePage";
import LifeMemberWelcomePage from "./pages/life";
import AdminLogin from "./pages/AdminLoginPage";
import AiotaMemberProfile from "./pages/AiotaMemberProfile";
import MembershipPayment from "./pages/MembershipPayment";
import Branches from "./pages/Branches";
import IJOT from "./pages/IJOT";
import IJOTIssues from "./pages/IJOTIssues";
import IJOTPromotions from "./pages/IJOTPromotions";
import IJOTNewsLetter from "./pages/IJOTNewsLetter";
import ContactUs from "./pages/ContactUs";
import FAQ from "./pages/FAQ";
import ChangePassword from "./pages/ChangePassword";
import FacotApplicationForm from "./pages/FacotApplicationForm";
import ProfessionalAdvancementForm from "./pages/ProfessionalAdvancementForm";
import PaymentSuccess from "./pages/PaymentSuccess";
import ForgotPassword from "./pages/ForgotPassword";
import LatestUpdatesPage from "./pages/LatestUpdatesPage";
import WFOTForm from "./pages/WFOTForm";
import WFOTPayment from "./pages/WFOTPayment";
import WFOTPaymentSuccess from "./pages/WFOTPaymentSuccess";
import FacotPayment from "./pages/FacotPayment";
import FacotPaymentSuccess from "./pages/FacotPaymentSuccess";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import WebinarForm from "./pages/WebinarForm";
import ScrollToTop from "./components/ScrollToTop";
import LicenseVerification from "./pages/LicenseVerification";
import LicenseVerificationForm from "./pages/LicenseVerificationForm";
import LicenseVerificationPayment from "./pages/LicenseVerificationPayment";
import LicenseVerificationPaymentSuccess from "./pages/LicenseVerificationPaymentSuccess";
import GoodStanding from "./pages/GoodStanding";
import GoodStandingForm from "./pages/GoodStandingForm";
import GoodStandingPayment from "./pages/GoodStandingPayment";
import GoodStandingPaymentSuccess from "./pages/GoodStandingPaymentSuccess";
import AdPopup from "./components/AdPopup";
import LicenseGoodStanding from "./pages/LicenseGoodStanding";
import AiotaMembersList from "./pages/AiotaMembersList";
import PresidentSecretary from "./pages/PresidentSecretary";
import Opportunities from "./pages/Opportunities";
import AdSubmission from "./pages/AdSubmission";
import AdSubmissionPayment from "./pages/AdSubmissionPayment";
import MembershipRenewalUpload from './pages/MembershipRenewalUpload';
import MembershipRenewalTerms from './pages/MembershipRenewalTerms';
import MembershipRenewalPayment from './pages/MembershipRenewalPayment';
import SmartRoute from "./components/SmartRoute";
import ErrorFallback from "./components/ErrorFallback";
import ProtectedRoute from "./ProtectedRoutes";
import MmeberOtpLogin from "./pages/LoginOtp";
import EdOtpLogin from "./pages/EdccloginOtp";
import IJOTIssueDetails from "./pages/IJOTIssueDetails";
import Awards from "./pages/Awards";
import PhotoGallery from "./pages/PhotoGallery";
import RegistrationSuccess from "./pages/RegistrationSuccess";
import RestrictedRoute from "./components/RestrictedRoute";

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />

        <Routes>
          {/* Auth routes outside of main */}
          <Route path="/member-login" element={<MemberLogin />} />
          <Route path="/registration-success" element={<RegistrationSuccess />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/edcc-login" element={<EDCCMemberLogin />} />

          {/* Main content routes */}
          <Route
            path="/"
            element={
              <main>
                <Home />
              </main>
            }
          />
          <Route
            path="/about-aiota"
            element={
              <main>
                <AboutAiota />
              </main>
            }
          />
          <Route
            path="/about-logo"
            element={
              <main>
                <AboutLogo />
              </main>
            }
          />
          <Route
            path="/vision"
            element={
              <main>
                <VisionMission />
              </main>
            }
          />
          <Route
            path="/executives"
            element={
              <main>
                <ExecutiveMembers />
              </main>
            }
          />
            <Route
            path="/otpmember"
            element={
              <main>
                <MmeberOtpLogin />
              </main>
            }
          />
           <Route
            path="/otpedccmember"
            element={
              <main>
                <EdOtpLogin />
              </main>
            }
          />
          <Route
            path="/elections"
            element={
              <main>
                <AiotaElections />
              </main>
            }
          />
          <Route
            path="/acot-executives"
            element={
              <main>
                <AcotExecutiveMembers />
              </main>
            }
          />
          <Route
            path="/accredited-colleges"
            element={
              <main>
                <OccupationalTherapyPrograms />
              </main>
            }
          />
          <Route
            path="/FACOT"
            element={
              <main>
                <GuidelinesPage />
              </main>
            }
          />
          <Route
            path="/resources"
            element={
              <main>
                <CertificationResources />
              </main>
            }
          />
          <Route
            path="/professional-advancement"
            element={
              <main>
                <ProfessionalAdvancement />
              </main>
            }
          />
          <Route
            path="/EDCC-Members"
            element={
              <main>
                <EDCCMembers />
              </main>
            }
          />
          <Route
            path="/Company-List"
            element={
              <main>
                <ErgonomicCertification />
              </main>
            }
          />
          <Route
            path="/wfot"
            element={
              <main>
                <WFOTMembership />
              </main>
            }
          />
          <Route
            path="/Contact-Us"
            element={
              <main>
                <ContactUs />
              </main>
            }
          />
          <Route
            path="/faq"
            element={
              <main>
                <FAQ />
              </main>
            }
          />
          <Route
            path="/payment-success"
            element={
              <main>
                <PaymentSuccess />
              </main>
            }
          />

          <Route
            path="/Download"
            element={
              <main>
                <DownloadsPage />
              </main>
            }
          />
          <Route
            path="/edcc-register"
            element={
              <main>
                <EDCCMemberRegister />
              </main>
            }
          />
          <Route element={<RestrictedRoute />}>
            <Route
              path="/terms-conditions"
              element={
                <main>
                  <LifeMembershipTerms />
                </main>
              }
            />
            <Route
              path="/stepper-form"
              element={
                <main>
                  <CombinedStepperForm />
                </main>
              }
            />
            <Route
              path="/old-member-terms-conditions"
              element={
                <main>
                  <OldMemberTermsConditions />
                </main>
              }
            />
            <Route
              path="/old-member-form"
              element={
                <main>
                  <OldMemberForm />
                </main>
              }
            />
          </Route>
          <Route
            path="/EDCCterms-conditions"
            element={
              <main>
                <EDCCTermsAndConditions />
              </main>
            }
          />
          <Route
            path="/edcc-old-member-terms"
            element={
              <main>
                <EDCCOldMemberTermsConditions />
              </main>
            }
          />
          {/* <Route path="/profile" element={
            <main>
              <ProfilePage />
            </main>
          } /> */}
          <Route
            path="/otp"
            element={
              <main>
                <EDCCLogin />
              </main>
            }
          />
          <Route
            path="/payment"
            element={
              <main>
                <AIOTAPaymentPage />
              </main>
            }
          />
        
          <Route
            path="/edccform"
            element={
              <main>
                <EDCCCombinedStepperForm />
              </main>
            }
          />
          <Route
            path="/edcc-old-member-form"
            element={
              <main>
                <EDCCOldMemberForm />
              </main>
            }
          />
          <Route
            path="/webinar"
            element={
              <main>
                <WebinarPage />
              </main>
            }
          />
          <Route
            path="/associate"
            element={
              <main>
                <AssociateMemberWelcomePage />
              </main>
            }
          />
          <Route
            path="/life"
            element={
              <main>
                <LifeMemberWelcomePage />
              </main>
            }
          />
          <Route path="/membership-payment" element={<MembershipPayment />} />


          <Route
            path="/branches"
            element={
              <main>
                <Branches />
              </main>
            }
          />
          <Route
            path="/IJOT"
            element={
              <main>
                <IJOT />
              </main>
            }
          />
          <Route
            path="/IJOT-Issues"
            element={
              <main>
                <IJOTIssues />
              </main>
            }
          />
          <Route
            path="/ijot-issues/:subid"
            element={
              <main>
                <IJOTIssueDetails />
              </main>
            }
          />
          <Route
            path="/IJOT-Promotions"
            element={
              <main>
                <IJOTPromotions />
              </main>
            }
          />
          <Route
            path="/News-Letter"
            element={
              <main>
                <IJOTNewsLetter />
              </main>
            }
          />
          <Route
            path="/change-password"
            element={
              <main>
                <ChangePassword />
              </main>
            }
          />
          <Route
            path="/facot-application-form"
            element={
              <main>
                <FacotApplicationForm />
              </main>
            }
          />
          <Route
            path="/professional-advancement-form"
            element={
              <main>
                <ProfessionalAdvancementForm />
              </main>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <main>
                <ForgotPassword />
              </main>
            }
          />
          <Route
            path="/latest-updates"
            element={
              <main>
                <LatestUpdatesPage />
              </main>
            }
          />
          <Route
            path="/wfot-form"
            element={
              <main>
                <WFOTForm />
              </main>
            }
          />
          <Route
            path="/wfot-payment"
            element={
              <main>
                <WFOTPayment />
              </main>
            }
          />
          <Route
            path="/wfot-payment-success"
            element={
              <main>
                <WFOTPaymentSuccess />
              </main>
            }
          />
          <Route
            path="/facot-payment"
            element={
              <main>
                <FacotPayment />
              </main>
            }
          />
          <Route
            path="/facot-payment-success"
            element={
              <main>
                <FacotPaymentSuccess />
              </main>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <main>
                <PrivacyPolicy />
              </main>
            }
          />
          <Route
            path="/terms-of-service"
            element={
              <main>
                <TermsOfService />
              </main>
            }
          />
          <Route
            path="/webinar-form"
            element={
              <main>
                <WebinarForm />
              </main>
            }
          />
          <Route
            path="/license-professional-status"
            element={
              <main>
                <LicenseGoodStanding />
              </main>
            }
          />
          <Route element={<RestrictedRoute />}>
            <Route
              path="/license-verification"
              element={
                <main>
                  <LicenseVerification />
                </main>
              }
            />
            <Route
              path="/license-verification-form"
              element={
                <main>
                  <LicenseVerificationForm />
                </main>
              }
            />
            <Route
              path="/license-verification-payment"
              element={
                <main>
                  <LicenseVerificationPayment />
                </main>
              }
            />
            <Route
              path="/license-verification-payment-success"
              element={
                <main>
                  <LicenseVerificationPaymentSuccess />
                </main>
              }
            />
            <Route
              path="/professional-status"
              element={
                <main>
                  <GoodStanding />
                </main>
              }
            />
            <Route
              path="/professional-status-form"
              element={
                <main>
                  <GoodStandingForm />
                </main>
              }
            />
            <Route
              path="/professional-status-payment"
              element={
                <main>
                  <GoodStandingPayment />
                </main>
              }
            />
            <Route
              path="/professional-status-payment-success"
              element={
                <main>
                  <GoodStandingPaymentSuccess />
                </main>
              }
            />
          </Route>
          <Route
            path="/membership-list"
            element={
              <main>
                <AiotaMembersList />
              </main>
            }
          />
          <Route
            path="/president-secretaries"
            element={
              <main>
                <PresidentSecretary />
              </main>
            }
          />
          <Route
            path="/opportunities"
            element={
              <main>
                <Opportunities />
              </main>
            }
          />
          <Route
            path="/ad-submission"
            element={
              <main>
                <AdSubmission />
              </main>
            }
          />
          <Route
            path="/ad-submission-payment"
            element={
              <main>
                <AdSubmissionPayment />
              </main>
            }
          />
          <Route
            path="/awards"
            element={<main><Awards /></main>}
          />
           <Route
            path="/photo-gallery"
            element={<main><PhotoGallery /></main>}
          />
          <Route element={<ProtectedRoute />}>
          <Route
            path="/aiota-member-profile"
            element={
              <main>
                <AiotaMemberProfile />
              </main>
            }
          />
            <Route
            path="/edccprofile"
            element={
              <main>
                <EDCCProfilePage />
              </main>
            }
          />
          {/* membership renewal */}
            <Route element={<RestrictedRoute />}>
              <Route
                path="/membership-renewal-upload"
                element={<MembershipRenewalUpload />}
              />
              <Route
                path="/membership-renewal-terms"
                element={<MembershipRenewalTerms />}
              />
              <Route
                path="/membership-renewal-payment"
                element={<MembershipRenewalPayment />}
              />
            </Route>
     
          </Route>
          {/* Add more routes here as needed */}
        </Routes>
        {/* <AdPopup/> */}
        <Footer />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;